import { Locale } from 'contentful';
import ContentfulService from './ContentfulService';

export default class MultiLocaleService extends ContentfulService {
	protected locales: Locale[] = [];

	protected defaultLocale: Locale;

	public constructor(locales: Locale[]) {
		super();
		this.locales = [...locales];
		this.defaultLocale = this.locales.find((locale: Locale): boolean => locale.default) as Locale;
	}

	protected mapToSingleLocaleObject(mulitLocaleObject: Record<string, any>, locale: Locale): any {
		let singleLocaleObject: Record<string, any> | undefined = mulitLocaleObject;

		if (mulitLocaleObject) {
			// i18n with locale
			if (mulitLocaleObject[locale.code]) {
				singleLocaleObject = mulitLocaleObject[locale.code];
			}
			// i18n with fallback locale
			else if (locale.fallbackCode && mulitLocaleObject[locale.fallbackCode]) {
				singleLocaleObject = mulitLocaleObject[locale.fallbackCode];
			}
			// i18n for empty default locale (fixes SALESAPP-339)
			// All other locales except the default locale have fallback locales, so they cannot be empty unless no locales are populated at all (^= unlocalized, empty field).
			// So we're save to assume the if the default locale code is not present but all others are, then the default locale must be empty and was hence not provided by contentful
			else if (
				locale.code === this.defaultLocale.code &&
				!locale.fallbackCode &&
				this.locales
					.filter((otherLocale: Locale): boolean => otherLocale.code !== locale.code)
					.every((otherLocale: Locale): boolean => mulitLocaleObject[otherLocale.code])
			) {
				singleLocaleObject = undefined;
			} else {
				const multiLocaleKeys: string[] = Object.keys(mulitLocaleObject);

				// non-i18n
				if (multiLocaleKeys.length === 1 && ![undefined, null].includes(mulitLocaleObject[this.defaultLocale.code])) {
					singleLocaleObject = mulitLocaleObject[this.defaultLocale.code];
				}
			}
		}

		const mapProperty = (property: any): any => {
			if (Array.isArray(property)) {
				return (property as any[]).map((item: any): any => mapProperty(item));
			}
			if (typeof property === 'object' && !!property) {
				const singleLocaleProperty: Record<string, any> = {};

				Object.keys(property).forEach((key: string): void => {
					singleLocaleProperty[key] = this.mapToSingleLocaleObject(property[key], locale);
				});

				return singleLocaleProperty;
			}
			return property;
		};

		return mapProperty(singleLocaleObject);
	}
}
